!function(name, module, context) {
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if (window.define)
		define('hotels/shortList',['libs/ct_pers', 'hotels/hotelPers', 'vendor/mustache', 'libs/ct_view', 'libs/ct_routes'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.Pers, Mustache, CT.View, CT.Routes)
}('shortListHotelsView', function(Pers, HotelPers, Mustache, View, Routes) {


	var shortListHotelsViewSettings = {

		attributes : {
		},



		initialize : function() {
			this.shortListHotels = CT.shortListHotels;
			this.shortListHotels[CT.settings.currentTab] = [];
			this.pers = new Pers()
		},



		events : {
			'list.update' : 'updateShortListHotels'
		},



		shortenID : function(id) {
            return jQuery.trim(id).substring(0, 4);
        },




		updateShortListHotels : function(e, data) {
			if(!data.ids) return this
	    	var that = this,
	    		hotelIds,hIdsObj,
	    		operation = data.operation;

	    	hIdsObj = (typeof(data.ids) == "object") ? data.ids[0] : data.ids
	    	hotelIds =  hIdsObj.split("-");

	    	if(operation == 'add') {
	    		var hids = hotelIds[0];
	    		hotelIds.splice(0,1);
		    	that.addHotel(hids, hotelIds, data.callerEvt);
		    }

		    if(operation == 'delete') {
		    	_.each(hotelIds, function(hId) {
		    		that.deleteHotel(hId);
		    	})
		    }
	    },




   		addHotel :  function(hotelId, hotelIds, callerEvt) {
   			var i = 0, j = 0, dataItem = null,
   				$shortlistBox = this.$el;
   				$parentResultElem = $shortlistBox.closest(".resultContainer"),
   				that = this,
	    		$hotelList = $parentResultElem.find('.listViewResults'),
            	$hBlock = $hotelList.find('#' + hotelId),
				$shortListBtn = $hBlock.find(".shortlistHotel");
			$parElem = $shortListBtn.parent();
			$shortListBtn.remove();
			$parElem.prepend(CT.messages.hotel.shortlisted);

	    	var hotelJson = CT.masterJson.get();
	    	var hotelList  = hotelJson.ht;
				while (i < hotelList.length) {
					if (hotelList[i].id === hotelId) {
	                    dataItem = hotelList[i];
	                    break;
	            }
	            i++;
	        }

	        var shortenID = this.shortenID(hotelId);
	        dataItem.shortID = shortenID;
			while (j < this.shortListHotels[CT.settings.currentTab].length) {
				if (this.shortListHotels[CT.settings.currentTab][j].id === hotelId) {
					return;
				}
				j++;
			}
			this.shortListHotels[CT.settings.currentTab].push(dataItem);
			$hBlock.attr("data-shortListHotel", "1");

   			if($shortlistBox.hasClass('stub'))
   				$shortlistBox.removeClass("stub");


    		if(this.shortListHotels[CT.settings.currentTab].length >1) {
    			$shortlistBox.find(".compareHotel").removeClass("disabled");
    		}

    		if(this.shortListHotels[CT.settings.currentTab].length == 0) {
    			$shortlistBox.find(".viewShortlistHotels").removeClass("disabled");
    		}

			$shortlistBox.find(".shortlist_count").html(this.shortListHotels[CT.settings.currentTab].length);
			if($parentResultElem.find("#ShortlistBarCount"))
				$parentResultElem.find("#ShortlistBarCount").html(this.shortListHotels[CT.settings.currentTab].length);
			html = Mustache.to_html(this.tpl.html(), {
				ht : dataItem
            });

			if(callerEvt !== "click") {
				$shortlistBox.find('#SItem').append(html);
				$(html).css('position','relative');
				if(typeof(hotelIds) != 'undefined' && hotelIds.length >0) {
	        		var thid = hotelIds[0];
		    		hotelIds.splice(0,1);
			    	that.addHotel(thid, hotelIds, callerEvt);
			    }
			} else {
		        /************* animation start ********************/
		        var sb = $shortlistBox.find(".shortHotels li");
		        var shbox_x;
		        if(sb.length >0) {
			   		shbox_x = $shortlistBox.position().left + $(sb[sb.length-1]).position().left + 23;
				} else {
					shbox_x = $shortlistBox.position().left + 106;
				}
				var shbox_y = $shortlistBox.position().top - $shortlistBox.height() + 13;

				var currPos = $hBlock.position(),
					currentXPos = currPos.left,
					currentYPos = currPos.top,
					diffX = shbox_x - currentXPos,
					diffY = shbox_y - currentYPos;

				//calculating hbox left and right
				var listPos = $hBlock.find("img").offset();
				var listXPos = listPos.left;
				var listYPos = listPos.top;


				$shdiv = $(html);
				$shdiv.addClass("upInTheAir");
				$shdiv.css({
	        		'top': listYPos + "px",
	        		'left': listXPos + "px",
	        		'position': 'absolute',
	        		'z-index' : '11'
	        	});

				$('body').append($shdiv);

				$shdiv.animate({'scale' : 0.4, left : shbox_x +"px", top : shbox_y +"px"}, 1, 'ease-in-out', function() {
					$shortlistBox.find('#SItem').append($shdiv);
					$shdiv.removeClass("upInTheAir")
					$shdiv.animate({'scale' : 1}, 1);

					$shdiv.css({
	        			'position' : 'relative',
	        			'z-index' : '',
	        			'left' : '',
	        			'top' : ''
	        		});
	        		if(typeof(hotelIds) != 'undefined' && hotelIds.length >0) {
		        		var thid = hotelIds[0];
			    		hotelIds.splice(0,1);
				    	that.addHotel(thid, hotelIds, callerEvt);
				    }
	     		});

	     		/**************animation stop ****************/

		        /*

		        saving shortlisted hotels in personalization
				{'name' : 'Bangalore', 'cid' : '12/10/12', 'cod' : '14/10/12', 'hids' : [1234, 5678]}

		        */


		        var searchParams = _.deserialize(window.location.search.substr(1).replace(/\+/g, ' '));

		        var tagHotels = this.shortListHotels[CT.settings.currentTab];
		        var cid = moment(searchParams.chk_in.replace(/\+/g, " ")).format("DD/MM/YY");
	      		var cod = moment(searchParams.chk_out.replace(/\+/g, " ")).format("DD/MM/YY");
		        var city=  searchParams.city.replace(/\+/g, " ");
		        var shJson = {'city' : city, 'cid' : cid, 'cod' : cod,  'hids' : _.pluck(tagHotels, 'id')};
		        this.pers.set('shortlisted', shJson);
			}
	    },


	    deleteHotel : function(hotelId) {
            var j = 0, $shortlistBox, $hotelList, $srpLiElem;
            $shortlistBox = this.$el;
   			$parentResultElem = $shortlistBox.closest(".resultContainer");
           	$listBlock = $shortlistBox.find('#' + hotelId);
           	var hotelJson = CT.masterJson.get();
            $hotelList = $parentResultElem.find('.listViewResults');
            $srpLiElem = $hotelList.find('#' + hotelId);

		    $labelElem = $srpLiElem.find("span.positive");
			$parElem = $labelElem.parent();
	    	$labelElem.remove();
	    	$parElem.prepend('<button class="pop shortlistHotel"><span class="element pin"></span>'+ CT.messages.hotel.Shortlist + '</button>');


            while (j < this.shortListHotels[CT.settings.currentTab].length) {
                if (this.shortListHotels[CT.settings.currentTab][j].id === hotelId) {
                        this.shortListHotels[CT.settings.currentTab].splice(j, j + 1);
                }
                j++;
            }

            $listBlock.remove();
	        if(this.shortListHotels[CT.settings.currentTab].length == 1) {
    			$shortlistBox.find(".compareHotel").addClass("disabled");
    		}

    		if(this.shortListHotels[CT.settings.currentTab].length == 0) {
    			$shortlistBox.find(".viewShortlistHotels").addClass("disabled");
    			$shortlistBox.addClass("stub");

    		}

	        $shortlistBox.find(".shortlist_count").html(this.shortListHotels[CT.settings.currentTab].length);
	        if($parentResultElem.find("#ShortlistBarCount"))
	        	$parentResultElem.find("#ShortlistBarCount").html(this.shortListHotels[CT.settings.currentTab].length);

	        var tagHotels = this.shortListHotels[CT.settings.currentTab];
	        var shJson = {'city' : hotelJson.city, 'hids' : _.pluck(tagHotels, 'id')};
	        this.pers.set('shortlisted', shJson);

	    }

	}
	return shortListHotelsViewSettings;
}, CT.settings)
;
